import { Navigate } from "react-router";

const base_url = process.env.REACT_APP_BASE_URL

export const PrivateRoutes = ({ children }) => {
    const getTokenFromLocalStorage = JSON.parse(localStorage.getItem("token"));

    // If not logged in, redirect to login
    if (getTokenFromLocalStorage === null) {
        return <Navigate to={`${base_url}/login`} replace="true" />;
    }
    // If logged in as an offline student, show the children
    return children;
}